import { useState, useEffect, useRef } from 'react';

export default function useDebouncedValue(input, time = 500) {
  const [debouncedValue, setDebouncedValue] = useState(input);

  const first = useRef(true);

  // every time input value has changed - set interval before it's actually commited
  useEffect(() => {
    // Don't change debouncedValue on first render
    if (first.current) {
      first.current = false;
      return;
    }

    const timeout = setTimeout(() => {
      setDebouncedValue(input);
    }, time);

    return () => {
      clearTimeout(timeout);
    };
  }, [input, time]);

  return debouncedValue;
}
